import { render, staticRenderFns } from "./VehicleSelectionItem.vue?vue&type=template&id=29a525e1&scoped=true&"
import script from "./VehicleSelectionItem.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectionItem.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSelectionItem.vue?vue&type=style&index=0&id=29a525e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a525e1",
  null
  
)

export default component.exports